import {MaybeUninitialised} from "modules/redux_types";
import UNINITIALISED from "utils/uninitialised";
import actionTypes from "../constants/action_types";

type Action = {
  type: string;
  payload?: unknown;
};

interface SecondaryDocumentState {
  data: MaybeUninitialised<unknown>;
  loading: boolean;
  error?: unknown;
}

const initialState: SecondaryDocumentState = {
  data: UNINITIALISED,
  loading: false,
  error: null,
};

export default function secondaryDocumentReducer(
  state: SecondaryDocumentState = initialState,
  action: Action,
): SecondaryDocumentState {
  if (action.type === actionTypes.SECONDARY_DOCUMENT_FETCH.REQUEST) {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }

  if (action.type === actionTypes.SECONDARY_DOCUMENT_FETCH.SUCCESS) {
    return {
      data: action.payload,
      loading: false,
      error: null,
    };
  }

  if (action.type === actionTypes.SECONDARY_DOCUMENT_FETCH.ERROR) {
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
  }

  if (action.type === actionTypes.SECONDARY_DOCUMENT_CLEAR.SUCCESS) {
    return initialState;
  }

  return state;
}
